import React from "react";
import {createRoot} from "react-dom/client";
import componentMapping from "./componentMapping";

/**
 * Initialize React components based on data-react-component attributes
 */
const initReactComponents = () => {
  // Find all elements with data-react-component attribute
  const reactElements = document.querySelectorAll("[data-react-component]");

  // Loop through each element
  reactElements.forEach(el => {
    const componentName = el.getAttribute("data-react-component");
    const Component = componentMapping[componentName];

    // Skip if component not found in mapping
    if (!Component) {
      console.warn(`React component "${componentName}" not found in component mapping`);
      return;
    }

    // Parse props from data-react-props attribute (if exists)
    let props = {};
    const propsAttr = el.getAttribute("data-react-props");
    if (propsAttr) {
      try {
        props = JSON.parse(propsAttr);
      } catch (e) {
        console.error(`Error parsing props for component "${componentName}":`, e);
      }
    }

    // Create root and render component
    try {
      const root = createRoot(el);
      root.render(<Component {...props} />);
    } catch (error) {
      console.error(`Error rendering React component "${componentName}":`, error);
    }
  });
};

export default initReactComponents;
